import { Th } from 'layouts/tableLayout/_th'
import { Tr } from 'layouts/tableLayout/_tr'
import useCustomerTHead from 'Pages/customer/hooks/useCustomerTHead'

export const CustomerTHead = ({ ...props }) => {

  const { globalLoading } = useCustomerTHead()

  return (
    <>
      <Tr {...props} type="tHead" >
        <Th className="customer-table__cell">Khách hàng</Th>
        <Th className="customer-table__cell">Cardcode</Th>
        <Th className="customer-table__cell">DTP phát hành 100%</Th>
        <Th className="customer-table__cell">Tổng đơn hàng</Th>
        <Th className="customer-table__cell">Tổng tiền</Th>
        <Th className="customer-table__cell">Cấu hình sản phẩm bán</Th>
        <Th className="customer-table__cell">Ngày phân công</Th>
        <Th className="customer-table__cell">Trạng thái</Th>
        <Th
          className="customer-table__cell"
          style={{ display: 'flex' }}
        />
      </Tr>
      {globalLoading.value && (
        <div className="customer-table__loading">
          <img src="/img/loading.gif"/>
        </div>
      )}
    </>
  )
}
